
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/login-as-fellow",
      function () {
        return require("private-next-pages/auth/login-as-fellow/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/login-as-fellow"])
      });
    }
  